module.exports = __webpack_public_path__ + "img/call.3df50170.svg";